import { render, staticRenderFns } from "./NativeAppLayout.vue?vue&type=template&id=ada364f2&scoped=true"
import script from "./NativeAppLayout.vue?vue&type=script&lang=ts"
export * from "./NativeAppLayout.vue?vue&type=script&lang=ts"
import style0 from "./NativeAppLayout.vue?vue&type=style&index=0&id=ada364f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada364f2",
  null
  
)

export default component.exports